import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = {amounts: [], total: ''}

const state = {
  collisionTypes: startState
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.collisionTypes = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.collisionTypes = startState
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.collisionTypes
}

export const CollisionTypes = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/barCharts/CollisionTypes.js